
    var riot = require('riot')
    riot.tag2('gb-collection-item', '<a class="gb-collection" data-collection="{$item.value || $item}" onclick="{$collections.switchCollection}"> <span class="gb-collection__name">{$item.label || $item}</span> <gb-badge if="{$collections.showCounts}">{$collections.counts[$item.value || $item]}</gb-badge> </a>', '', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/collections/gb-collection-item.tag.html